import {AuthContext} from "../Context/ContextApi"
import {useContext} from "react"
import { Navigate } from "react-router-dom"

function PrivateRoutes({children}){
const {auth} = useContext(AuthContext)
if(!auth){
    return <Navigate to="/login"></Navigate>
}

return children

}

export default PrivateRoutes